// Canonical definition of the routes that require authentication.
//
// Two places need it and must never disagree:
// - `src/proxy.js`, which redirects unauthenticated page loads of these paths
//   to /sign-in/, and turns unauthenticated client-side navigations to them
//   into full page loads (CON-9069: since Next.js 16.3 the App Router caches
//   a redirected client navigation and replays it after sign-in)
// - `node-modules-mocks/react-router-dom/LinkMock.js`, which disables
//   prefetching for them (CON-8199: prefetching a protected route while
//   logged out makes the App Router cache the redirect-to-/sign-in/
//   resolution and replay it post-login)
//
// Keep this module dependency-free: it is bundled into the proxy
// (middleware), which runs on every request.

// Protected route prefixes that require authentication
export const PROTECTED_ROUTE_PREFIXES = ['/customer', '/quote', '/wishlist'];

// Routes that should be excluded from protection (even if they match protected prefixes).
export const EXCLUDED_ROUTE_PREFIXES = [
  '/customer-photos/',
  // Both password-reset link shapes (/customer/reset-password/<token>/ and
  // /customer/reset-password/customer/<token>/). Protecting them would loop:
  // proxy.js sends them to /sign-in/, which redirects straight back.
  '/customer/reset-password/',
];

export default function isProtectedRoute(pathname) {
  if (typeof pathname !== 'string') {
    return false;
  }

  // Normalize to a trailing-slash form so excluded routes like "/customer-photos/"
  // still match when the incoming request is "/customer-photos".
  const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;

  // First check if the route is explicitly excluded (prefix or exact match)
  if (
    EXCLUDED_ROUTE_PREFIXES.some(
      route => normalizedPath === route || normalizedPath.startsWith(route)
    )
  ) {
    return false;
  }

  // Then check if it matches any protected prefix
  return PROTECTED_ROUTE_PREFIXES.some(prefix =>
    normalizedPath.startsWith(prefix)
  );
}
